import React from 'react';
import FormInput from '../input/FormInput';
import { useFormContext } from 'react-hook-form';

const SiloInvoiceCarryOver = ({ name, props, user }) => {
    const { getValues } = useFormContext();

    const { carry_over, invoice_number } = getValues(name);

    return (
        <FormInput
            name={name}
            props={{
                label: invoice_number ? `Carry Over from invoice #${invoice_number}` : 'Carry Over from Previous Silo',
                InputProps: { inputProps: { min: 0, step: 0.01 } },
                variant: 'outlined',
                valueAsNumber: true,
                value: carry_over ?? 0,
                ...props,
            }}
            user={user}
        />
    );
};

export default SiloInvoiceCarryOver;
